import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { InsuranceDoc } from '../_models/insuranceDoc';

@Injectable()
export class InsuranceDocService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getInsuranceDocs(): Observable<InsuranceDoc[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/insuranceDocs')
      .pipe(map((response) => response));
  }

  getInsuranceDoc(id: number): Observable<InsuranceDoc> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/insuranceDocs/' + id)
      .pipe(map((response) => response));
  }

  saveInsuranceDoc(insuranceDocItem: InsuranceDoc): Observable<InsuranceDoc> {
    const insuranceDoc = { ...insuranceDocItem };
    delete insuranceDoc.lastUpdated;
    delete insuranceDoc.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    insuranceDoc.companyId = companySelected ? companySelected.id : null;

    if (insuranceDoc.id) {
      return this.http
        .put<InsuranceDoc>(
          this.apiBaseUrl + 'api/private/v1/insuranceDocs/' + insuranceDoc.id,
          insuranceDoc
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<InsuranceDoc>(this.apiBaseUrl + 'api/private/v1/insuranceDocs/', insuranceDoc)
        .pipe(map((response) => response));
    }
  }

  deleteInsuranceDoc(id: number): Observable<InsuranceDoc> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/insuranceDocs/' + id).pipe(
      map(() => {
        return { id } as InsuranceDoc;
      })
    );
  }
}
